import {
  Component,
  HostBinding,
  OnInit,
  Renderer2,
  ElementRef,
} from '@angular/core';
import {Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError} from '@angular/router';
import { filter } from 'rxjs/operators';
import { SettingsService, TitleService } from '@delon/theme';
import { VERSION as VERSION_ALAIN } from '@delon/theme';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd';
import { WatermarkService } from '@core/watermark';

@Component({
  selector: 'app-root',
  template: `<nz-spin [nzSpinning]="routerState" [nzSize]="'large'" class="router_spin"><router-outlet></router-outlet></nz-spin>`,
})
export class AppComponent implements OnInit {
  @HostBinding('class.layout-fixed')
  get isFixed() {
    return this.settings.layout.fixed;
  }
  @HostBinding('class.layout-boxed')
  get isBoxed() {
    return this.settings.layout.boxed;
  }
  @HostBinding('class.aside-collapsed')
  get isCollapsed() {
    return this.settings.layout.collapsed;
  }

  public routerState:boolean = false;
  constructor(
    el: ElementRef,
    renderer: Renderer2,
    private settings: SettingsService,
    private router: Router,
    private titleSrv: TitleService,
    private watermarkService: WatermarkService,
  ) {
    renderer.setAttribute(
      el.nativeElement,
      'ng-alain-version',
      VERSION_ALAIN.full,
    );
    renderer.setAttribute(
      el.nativeElement,
      'ng-zorro-version',
      VERSION_ZORRO.full,
    );

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.routerState = true;
      }

      if (event instanceof NavigationError || event instanceof NavigationCancel){
        this.routerState = false;
      }

      if (event instanceof NavigationEnd) {
        this.routerState = false;
      }
    });
  }

  ngOnInit() { 
    // 初始化全局水印（文字由 WatermarkService 内部根据登录状态自动处理）
    this.watermarkService.create();

    // 路由导航结束后刷新水印（覆盖登录/登出场景）
    this.router.events
      .pipe(filter(evt => evt instanceof NavigationEnd))
      .subscribe(() => {
        this.titleSrv.setTitle();
        this.watermarkService.refresh();
      });
  }
}
